import { render } from "./jjcg.vue?vue&type=template&id=733cf759&scoped=true&ts=true"
import script from "./jjcg.vue?vue&type=script&lang=ts"
export * from "./jjcg.vue?vue&type=script&lang=ts"

import "./jjcg.vue?vue&type=style&index=0&id=733cf759&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-733cf759"]])

export default __exports__